import { render } from "./pageNot.vue?vue&type=template&id=3985e4d8"
import script from "./pageNot.vue?vue&type=script&lang=js"
export * from "./pageNot.vue?vue&type=script&lang=js"

import "./pageNot.vue?vue&type=style&index=0&id=3985e4d8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__